import {combineReducers} from 'redux';
import  agreementReducer  from './company/reducers/get-agreement';
import  displayDetailsReducer  from './company/reducers/display-details';
import  createCompInfoReducer  from './company/reducers/create-comp-info';
import  createCommodityReducers  from './commodities-services/reducers/create-commodity';

const combinedReducers = combineReducers({agreementdata:agreementReducer,
                                          formdetaildata:displayDetailsReducer,
                                          modaldata:createCompInfoReducer,
                                          comModaldata:createCommodityReducers});

export default combinedReducers;